<div class="container">
    <div *ngIf="pdfUrl">
        <iframe [src]="pdfUrl" width="100%" height="77%"> 
        </iframe>        
    </div>
</div>